var map = {
	"./BOD-msg.jpg": "c66e",
	"./Comprehensive-Income.jpg": "7fc7",
	"./Consolidated-Statement-of-Profit-or-Loss.jpg": "a682",
	"./Financial-Position-.jpg": "43b9",
	"./Independent-Auditor-Report.jpg": "ed13",
	"./KPIs.jpg": "0460",
	"./Remuneration_report.jpg": "73c0",
	"./board-committee.jpg": "9383",
	"./board_of_directors.jpg": "167e",
	"./board_of_directors_governance.jpg": "98d7",
	"./business_operation.jpg": "80d0",
	"./cash-flows.jpg": "0a15",
	"./code-of-conduct.jpg": "b552",
	"./commercial.jpg": "90d9",
	"./coroprate_sustainability.jpg": "7765",
	"./disclosiure.jpg": "8b92",
	"./diversity.jpg": "68e4",
	"./executive_management.jpg": "e4f1",
	"./financial-reporting.jpg": "7e6e",
	"./galance.jpg": "35ec",
	"./governance-BOD.jpg": "8712",
	"./governance_introduction.jpg": "da36",
	"./key_milestones.jpg": "9a05",
	"./members_of_board.jpg": "77cf",
	"./notes-to-financial-statements.jpg": "09bf",
	"./performance-management.jpg": "a735",
	"./regulatory.jpg": "64b1",
	"./remutation_report.jpg": "fdea",
	"./risk_management.jpg": "195b",
	"./risk_management_and_internal.jpg": "4174",
	"./shareholders_rights.jpg": "6c9f",
	"./shareholders_rights1.jpg": "72b8",
	"./stakeholders-rights.jpg": "9966",
	"./strategy.jpg": "c20f",
	"./sustainability.png": "3af8",
	"./technology.jpg": "d489",
	"./vice_chairman_and_ceo_statement.jpg": "8c21",
	"./year_in_review.jpg": "d5e7",
	"./year_in_review1.jpg": "8ec4",
	"./zain-world.jpg": "8696",
	"./zain_drone.jpg": "d06f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0f1d";